import styled from 'styled-components';

export const NavIcon = styled.img`
  display: inline-block;
  height: 24px;
  margin-right: 0.5rem;
  vertical-align: middle;
`;
